module.exports = "/fast-coin/img/coin/anim/out_1/out_1_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_001.png
// module id = 2297
// module chunks = 5